import ClassNames from 'classnames';
import React, { Component } from 'react';

import ModalActions from '../../../actions/TabletsModalActions';
import AdvancedTab from './AdvancedTab';
import SuppliersTab from './suppliers/SuppliersTab';
import TabletTab from './TabletTab';

export default class FilterModal extends Component {
    constructor(props) {
        super(props);
        this.actions = props.actions;
        this.modalActions = new ModalActions(this);

        this.state = {
            modalCriteria: this.props.criteria
        };

        this.selectTab = this.selectTab.bind(this);
        this.onSuppliersChanged = this.onSuppliersChanged.bind(this);
        this.onModalHidden = this.onModalHidden.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
    }

    componentDidMount() {
        this.bindModal();
        wo$('#modal-results-tablets').on('hidden.bs.modal', this.onModalHidden);

        this.showModal();
    }

    componentWillUnmount() {
        wo$('#modal-results-tablets').off('hidden.bs.modal', this.onModalHidden);
    }

    bindModal() {
        //ToDo: Move to adaptor
        const modal = wo$('#modal-results-tablets');
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        modal.on('hidden.bs.modal', () => that.actions.modalHidden());
    }

    showModal() {
        WhistleOut.trackEvent('SearchResults', 'SearchModal', 'Show');

        //ToDo: Move to adaptor
        const modal = wo$('#modal-results-tablets');
        modal.modal('show');
    }

    selectTab(e) {
        this.actions.selectTab(e.currentTarget.getAttribute('data-tab-name'));
    }

    applyFilters() {
        const updatedState = {
            criteria: this.state.modalCriteria
        };

        this.actions.search(updatedState);
    }

    onSuppliersChanged(selectedShortUrls, customerType, networkIds) {
        this.modalActions.changeSelectedSuppliers(selectedShortUrls, customerType, networkIds);
    }

    onModalHidden() {
        if (this.props.onModalHidden) {
            this.props.onModalHidden();
        }
    }

    render() {
        if (!this.props.modal.isOpen) {
            return null;
        }

        const tabNames = [
            {
                name: 'tablet',
                text: this.props.resources.tablet,
                class: 'fa fa-cloud fa-fw position-absolute-lg position-absolute-md',
                isActive: this.props.modal.activeTab === 'tablet'
            },
            {
                name: 'carriers',
                text: this.props.resources.carriers,
                class: 'fa fa-check-square fa-fw position-absolute-lg position-absolute-md',
                isActive: this.props.modal.activeTab === 'carriers'
            },
            {
                name: 'advanced',
                text: this.props.resources.advanced,
                class: 'fa fa-cog fa-fw position-absolute-lg position-absolute-md',
                isActive: this.props.modal.activeTab === 'advanced'
            }
        ];

        const tabMenuItems = tabNames.map(item => {
            return (
                <li
                    key={item.name}
                    className={ClassNames('text-center mar-b-2', { active: item.name === this.props.modal.activeTab })}
                >
                    <a
                        href="javascript:void(0)"
                        data-show-tab={`modal-results-tablets-${item.name}`}
                        data-tab-name={item.name}
                        onClick={this.selectTab}
                        className="pad-x-3 pad-x-1-xs pad-y-2 pad-y-4-xs text-left text-center-xs"
                    >
                        <strong className="font-4 pad-l-5 pad-l-0-sm pad-l-0-xs display-block position-relative">
                            <span className="hidden-sm">
                                <i className={item.class} />
                            </span>
                            <span className="hidden-xs">{item.text}</span>
                        </strong>
                    </a>
                </li>
            );
        });

        const createTabContent = (name, children) => (
            <div
                className={ClassNames('tab-pane', {
                    active: tabNames.filter(t => t.name === name)[0].isActive
                })}
                id={`modal-results-tablets-${name}`}
            >
                {children}
            </div>
        );

        return (
            <div
                className="modal fade"
                id="modal-results-tablets"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modal-results-tablets"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header pad-t-5 pad-b-3">
                            <div className="row">
                                <div className="col-xs-8 col-sm-12 text-left">
                                    <strong className="font-7" id="modal-results-tablets-filter">
                                        {this.props.resources.filter}
                                        <span className="hidden-xs"> {this.props.resources.results}</span>
                                    </strong>
                                </div>
                                <div className="col-xs-16 col-sm-12 text-right">
                                    <button className="btn btn-info" data-dismiss="modal">
                                        {this.props.resources.cancel}
                                    </button>
                                    <button
                                        onClick={this.applyFilters}
                                        className="btn btn-primary mar-l-2"
                                        data-dismiss="modal"
                                    >
                                        {this.props.resources.applyAll}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="[ col-xs-5 ] [ col-md-4 ] ">
                                    <ul className="nav nav-pills nav-stacked">{tabMenuItems}</ul>
                                </div>
                                <div className="[ col-xs-19 ] [ col-sm-18 col-sm-offset-1 ] [ col-md-19 col-md-offset-1 ]">
                                    <div className="tab-content">
                                        {createTabContent(
                                            'tablet',
                                            <TabletTab
                                                key={`tablet${this.props.modal.isOpen}`}
                                                {...this.props}
                                                criteria={this.state.modalCriteria}
                                                modalActions={this.modalActions}
                                            />
                                        )}
                                        {createTabContent(
                                            'carriers',
                                            // Use 'isOpen' to modify the 'key' attribute, this will force the React element to reset not applied filters
                                            <SuppliersTab
                                                key={`suppliers${this.props.modal.isOpen}`}
                                                resources={this.props.resources}
                                                selectedShortUrls={this.state.modalCriteria.common.suppliers.values}
                                                selectedNetworkIds={this.state.modalCriteria.networkIds}
                                                customerType={this.state.modalCriteria.common.customerType}
                                                hasAddress={!!this.state.modalCriteria.common.address}
                                                onSelectionChanged={this.onSuppliersChanged}
                                                suppliers={this.props.suppliers.items}
                                            />
                                        )}
                                        {createTabContent(
                                            'advanced',
                                            <AdvancedTab
                                                key={`advanced${this.props.modal.isOpen}`}
                                                {...this.props}
                                                criteria={this.state.modalCriteria}
                                                modalActions={this.modalActions}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer pad-t-5 pad-b-3 visible-xs">
                            <div className="row">
                                <div className="col-xs-24 text-right">
                                    <button className="btn btn-info" data-dismiss="modal">
                                        {this.props.resources.cancel}
                                    </button>
                                    <button
                                        className="btn btn-primary mar-l-2"
                                        onClick={this.applyFilters}
                                        data-dismiss="modal"
                                    >
                                        {this.props.resources.applyAll}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
